import React, { useState } from "react";
import { Button, Dropdown, Menu, Input, Tooltip } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { useMaintenanceModel } from "../maintenanceModel";
import { useMaintenanceDetailsModel } from "../view/details/maintenanceDetailsModels";
import { IDescription, DescriptionColorEnum } from "@/components/YhBox/Types";
import { useDeliveryDetailsModel } from "@/views/stock/delivery/view/details/deliveryDetailsModel";
import useGlobalModel from "@/model/globalModel";
import { repairFormatNum } from "@/utils/utils";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { ViewReport } from "./viewReport";


export const DataBox = () => {
    const {
        selectedRowKeys,
        selectedRow,
        invalidateData,
        tran, tranOut,
        exportMaintenance,
        descTotal,
        rowsDescTotal,
        setScaniaPrint,
        setSettleScaniaPrint,
        detailsExport,
        setPrint,
        detailsNoPriceExport,
        ExportOfOutboundLedger,
        mainRepairFormExport,
        setPrintVisible, setPrintSettleVisible,
    } = useMaintenanceModel();
    const { shopAndOrg: { shopCode } } = useGlobalModel()
    const { resetEditCatch: resetDeliveryEditCatch } = useDeliveryDetailsModel()
    const { resetEditCatch } = useMaintenanceDetailsModel()
    const { selectedNavId, replaceNav, addNav, findNav, selectNav, switchNavState } = useNavModel();

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        if (selectedRow.status === "maintenance.change") {
            globalPrompt("message", { text: "该单据已作废，无法进行编辑", type: "warning" });
            return;
        }
        if (selectedRow.status === "maintenance.chacompletednge") {
            globalPrompt("message", { text: "该单据已完工，无法进行编辑", type: "warning" });
            return;
        }
        // if (selectedRow.status === "maintenance.settle") {
        //     globalPrompt("message", { text: "该单据已结算，无法进行编辑", type: "warning" });
        //     return;
        // }
        let saleOrderEditKey = "4-1-2";
        let isFindNav = findNav(saleOrderEditKey);
        if (!isFindNav) {
            addNav(saleOrderEditKey, { id: selectedRow.maintenanceCode as string, mode: "edit", parentInfo: { selectedNavId } });
        } else {
            globalPrompt("modal", {
                title: "维修管理跳转详情",
                type: "warning",
                text: "您还有维修管理详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(saleOrderEditKey, { id: selectedRow.maintenanceCode as string, mode: "edit", parentInfo: { selectedNavId } });
                    resetEditCatch()
                }
            })
        }
    }
    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let supplierEditKey = "4-1-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: selectedRow.maintenanceCode as string, mode: "look", parentInfo: { selectedNavId } },
            true
        );
    }
    const onTrunShop = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        if (selectedRow.status === "maintenance.change") {
            globalPrompt("message", { text: "该单据已作废，无法进行转车间", type: "warning" });
            return;
        }
        if (selectedRow.status === "maintenance-status.wxd") {
            globalPrompt("message", { text: "该单据已转外修，无法进行转车间", type: "warning" });
            return;
        }
        if (selectedRow.status === "maintenance.completed") {
            globalPrompt("message", { text: "该单据已完工，无法进行转车间", type: "warning" });
            return;
        }
        if (selectedRow.status === "maintenance-status.final") {
            globalPrompt("message", { text: "该单据已终检，无法进行转车间", type: "warning" });
            return;
        }
        if (selectedRow.status === "maintenance.settle") {
            globalPrompt("message", { text: "该单据已结算，无法进行转车间", type: "warning" });
            return;
        }
        if (selectedRow.status === "maintenance.underway") {
            globalPrompt("message", { text: "该单据已在修，无法进行转车间", type: "warning" });
            return;
        }
        if (selectedRow.status === "maintenance.await") {
            globalPrompt("message", { text: "该单据已待修，无法进行转车间", type: "warning" });
            return;
        }
        globalPrompt("modal", {
            title: "维修单同时转车间和库房",
            type: "success",
            text: "",
            okText: "确定",
            onOk: () => {
                let obj = {
                    id: selectedRow.id,
                    maintenanceCode: selectedRow.maintenanceCode,
                }
                tran(obj).then(res => {
                    if (res) {
                        globalPrompt("message", { text: `工单单号${selectedRow.maintenanceCode}转接成功`, type: "success" });
                        // addNav("6-1")
                    }
                })
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })
    }
    const onTrunOut = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        if (selectedRow.status === "maintenance.change") {
            globalPrompt("message", { text: "该单据已作废，无法转外修", type: "warning" });
            return;
        }
        if (selectedRow.status === "maintenance-status.wxd") {
            globalPrompt("message", { text: "该单据已转外修，无法转外修", type: "warning" });
            return;
        }
        if (selectedRow.status === "maintenance.completed") {
            globalPrompt("message", { text: "该单据已完工，无法转外修", type: "warning" });
            return;
        }
        if (selectedRow.status === "maintenance-status.final") {
            globalPrompt("message", { text: "该单据已终检，无法转外修", type: "warning" });
            return;
        }
        if (selectedRow.status === "maintenance.settle") {
            globalPrompt("message", { text: "该单据已结算，无法转外修", type: "warning" });
            return;
        }
        globalPrompt("modal", {
            title: "维修单转外修单",
            type: "success",
            text: "",
            okText: "确定",
            onOk: () => {
                tranOut((selectedRow.id as string)).then(res => {
                    if (res) {
                        globalPrompt("message", { text: `工单单号${selectedRow.maintenanceCode}转外修成功`, type: "success" });
                        // addNav("6-1")
                    }
                })
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })
    }
    const onPrint = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        setPrint(true)
    }

    const onInvalidate = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let cancelReason: string = ""
        globalPrompt("modal", {
            title: "维修单作废",
            type: "error",
            text: <><span>请输入作废原因</span>
                <Input onChange={(e) => { cancelReason = e.target.value }} /></>,
            okText: "确定",
            onOk: () => {
                let obj = {
                    id: selectedRow.id,
                    maintenanceCode: selectedRow.maintenanceCode,
                    cancelReason
                }
                invalidateData(obj)
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })

    }
    const onDelivery = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        if (selectedRow.status === "maintenance.underway" || selectedRow.status === "maintenance.await") {
            let saleOrderEditKey = "9-3-2";
            let isFindNav = findNav(saleOrderEditKey);
            if (!isFindNav) {
                addNav(saleOrderEditKey, { id: selectedRow.maintenanceCode as string, mode: "edit" });
            } else {
                globalPrompt("modal", {
                    title: "维修出库跳转详情",
                    type: "warning",
                    text: "您还有维修出库详情未保存，是否跳转",
                    okText: "跳转未保存页",
                    onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                    cancelText: "打开新页签",
                    onCancel: () => {
                        switchNavState(saleOrderEditKey, { id: selectedRow.maintenanceCode as string, mode: "edit" });
                        resetDeliveryEditCatch()
                    }
                })
            }
        } else if (selectedRow.status === "maintenance.settle" || selectedRow.status === "maintenance.completed" || selectedRow.status === "maintenance-status.final") {
            let supplierEditKey = "9-3-3";
            replaceNav(
                selectedNavId,
                supplierEditKey,
                { id: selectedRow.maintenanceCode as string, mode: "look", },
                true
            );
        } else {
            globalPrompt("message", { text: "您的工单不是在修,待修,已结算，已完工状态，不能进行维修出库操作", type: "warning" });
            return;
        }
    }
    const onSknyPrint = (type: number) => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        setScaniaPrint({ visible: true, type })
    }
    const onSettleSknyPrint = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        setSettleScaniaPrint(true)
    }
    const PrintMenu = () => {
        return (
            <Menu>
                <Menu.Item key="0">
                    <span onClick={() => onSknyPrint(1)}>工单打印</span>
                </Menu.Item>
                <Menu.Item key="2">
                    <span onClick={() => onSknyPrint(0)}>工单无单价打印</span>
                </Menu.Item>
                <Menu.Item key="1">
                    <span onClick={onSettleSknyPrint}>结算打印</span>
                </Menu.Item>
                <Menu.Item key="3">
                    <span onClick={() => onPrint()}>财务打印</span>
                </Menu.Item>
            </Menu>
        )
    }
    const exportMenu = () => {
        return (
            <Menu>
                <Menu.Item key="0">
                    <span onClick={() => exportMaintenance()}>列表导出</span>
                </Menu.Item>
                <Menu.Item key="1">
                    <span onClick={() => detailsExport()}>详情导出</span>
                </Menu.Item>
            </Menu>
        )
    }
    //查看报告
    const [viewReportInfo, setViewReportInfo] = useState<any>({
        visible: false,
        orderId: '',
        setViewReportInfo: ''
    })

    const openViewReport = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择你要查看报告的工单，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        if (!(selectedRow.status == "maintenance-status.final" || selectedRow.status == "maintenance.settle")) {
            globalPrompt("message", { text: "单据状态在终检后才可查看报告！", type: "warning" });
            return;
        }
        setViewReportInfo({ visible: true, orderId: selectedRowKeys[0], maintenanceCode: selectedRow.maintenanceCode })
    }
    const action = <>
        <YhAuth resCode={ResourceAuthEnum.M_AD}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => addNav('4-1-1', { id: "", mode: "add", parentInfo: { selectedNavId } })}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.M_ED}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.M_VW}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onLook}
            >查看</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.M_TRANS}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onTrunShop}
            >转接</Button>
        </YhAuth>

        <YhAuth resCode={ResourceAuthEnum.M_M_OUT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onDelivery}
            >维修出库</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.M_CANCEL}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onInvalidate}
            >作废</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.M_EX}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => detailsExport().then()}
            >导出</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.VRM2_REPAIR_EXNOPRICE}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => detailsNoPriceExport()}
            >明细导出(无单价)</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.M_PRINT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => onPrint()}
            >结算单打印</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.M_PRINT2}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => { setPrintSettleVisible(true) }}
            >结算单批量打印</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.M_WXPRINT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => { setPrintVisible(true) }}
            >维修单打印</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.VRM2_REPAIR_TRANSFEROUT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onTrunOut}
            >转外修</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.VRM2_REPAIR_EXPORTOFOUTBOUNDLEDGE}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => ExportOfOutboundLedger()}
            >出库台账导出</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.VRM2_REPAIR_MAINREPAIRFORMEXPORT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => mainRepairFormExport()}
            >主单导出</Button>
        </YhAuth>
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={() => openViewReport()}
        >查看报告</Button>
    </>;
    const desc: IDescription[] = [
        {
            label: "工时数",
            value: selectedRowKeys.length === 0 ? descTotal.workHour : repairFormatNum(rowsDescTotal.workHour),
            color: DescriptionColorEnum.red
        },
        {
            label: "配件数",
            value: selectedRowKeys.length === 0 ? descTotal.materialNum : repairFormatNum(rowsDescTotal.materialNum),
            color: DescriptionColorEnum.red
        },
        {
            label: "费用合计",
            value: selectedRowKeys.length === 0 ? descTotal.totalAmount : repairFormatNum(rowsDescTotal.totalAmount),
            color: DescriptionColorEnum.red
        },
        {
            label: "优惠金额",
            value: selectedRowKeys.length === 0 ? descTotal.discountTotalAmount : repairFormatNum(rowsDescTotal.discountTotalAmount),
            color: DescriptionColorEnum.red
        },
        {
            label: "营业额",
            value: selectedRowKeys.length === 0 ? descTotal.receivableTotalAmount : repairFormatNum(rowsDescTotal.receivableTotalAmount),
            color: DescriptionColorEnum.red
        },
        {
            label: "已收金额",
            value: selectedRowKeys.length === 0 ? descTotal.receivableAmount : repairFormatNum(rowsDescTotal.receivableAmount),
            color: DescriptionColorEnum.red
        },
    ]
    return (
        <>
            <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
                <DataTable />
            </YhBox>
            {
                viewReportInfo.visible && <ViewReport visible={viewReportInfo.visible} orderId={viewReportInfo.orderId}
                    maintenanceCode={viewReportInfo.maintenanceCode}
                    setViewReportInfo={setViewReportInfo} />
            }
        </>
    )
}